<template>
  <!-- Register Component -->
  <v-container>
    <parameter ref="param" @error="onError" @id="onId"></parameter>
  </v-container>
</template>

<script>
import breakpointMixin from "../../mixins/breakpointMixin";
import paramCtrl from "@/components/controls/parameter";
import router from "@/router";
import settingsService from "@/_services/settings-service";
import store from "@/store";

export default {
  name: "register-view",
  components: {
    "parameter": paramCtrl,
  },

  data: () => ({
  }),

  mixins: [breakpointMixin],

  mounted() {
    const data = {
      cancelUrl: settingsService.get("cancelUrl"),
      returnUrl: settingsService.get("registerUrl"),
      process: "register",
    };
    this.$refs.param.create(data);
  },

  methods: {
    onId(id) {
      window.location.href = settingsService.get("remoteRegisterUrl") + id; 
    },

    onError() {
      // console.log(error);
    }
  },
  router: router,
  store: store,
};
</script>
<style lang="scss" scoped>
.v-card {
  margin-right: 15px;
}
.v-btn {
  margin-bottom: 20px;
  margin-left: 10px;
}
</style>
